export enum ZIndex {
  Background = 1,
  Talk = 5,
  FloatingImage = 10,
  AutotapController = 100,
  ViewerMenu = 110,
  TopDisplayAdbox = 110,
  FullScreen = 150,
  Tutorial = 200,
  Loading = 300,
}
